module.exports = __webpack_public_path__ + "img/enter.2c20e55e.svg";